export const supertagTok = ['d29b3be8f2cc9a1a7051', '20028716136f69533e19', 'fafdf33f419367ee7921'];

export const defaultTok = ['61697266696e64657200']